module.exports = __webpack_public_path__ + "static/media/lykke10.35fae7ae.jpg";